import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsPlanEntryTaxiDriverRecalculate from "./billings-plan-entry-taxi-driver-recalculate";
import BillingsPlanEntryTaxiDriverRecalculateParams from "./billings-plan-entry-taxi-driver-recalculate-params";

const useRecalculatePlanEntryTaxiDriverBillings = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsPlanEntryTaxiDriverRecalculate | null>(null);

  const load = async (
    params: BillingsPlanEntryTaxiDriverRecalculateParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const recalculateTaxiDriverBillings =
        await billingService.recalculatePlanEntryTaxiDriverBillings(
          params,
          signal,
        );

      setData(recalculateTaxiDriverBillings);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useRecalculatePlanEntryTaxiDriverBillings;
